export default `
<svg
  aria-hidden="true"
  aria-label="radio-checked"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M9 12C9 10.3438 10.3125 9 12 9C13.6562 9 15 10.3438 15 12C15 13.6562 13.6562 15 12 15C10.3125 15 9 13.6562 9 12ZM20 12C20 16.4375 16.4062 20 12 20C7.5625 20 4 16.4375 4 12C4 7.59375 7.5625 4 12 4C16.4062 4 20 7.59375 20 12ZM12 5.5C8.40625 5.5 5.5 8.4375 5.5 12C5.5 15.5938 8.40625 18.5 12 18.5C15.5625 18.5 18.5 15.5938 18.5 12C18.5 8.4375 15.5625 5.5 12 5.5Z"
    fill="currentcolor"
  />
</svg>
`;
